// import Chooseus from "../components/LandingPageSections/ChooseUs";
import { Link } from "react-router-dom";

import * as api from "../api/index";

import Chooseus from "../Components/LandingPageSections/ChooseUs";
import Contact from "../Components/LandingPageSections/Contact";
import FAQs from "../Components/LandingPageSections/FAQs";
import Home from "../Components/LandingPageSections/Home";
import OurTeam from "../Components/LandingPageSections/OurTeam";
import Qualities from "../Components/LandingPageSections/Qualities";
import Reviews from "../Components/LandingPageSections/Reviews";
import Services from "../Components/LandingPageSections/Services";
import Working from "../Components/LandingPageSections/Working";
import Footer from "../Components/Layout/Footer";
import Topbar from "../Components/Layout/Topbar";
import "./LandingPage.scss";

import React, { useState } from "react";

const LandingPage = () => {
  const [showDropDown, setShowDropDown] = useState(false);

  const logoutHandler = async () => {
    const result = await api.logoutApi();
    if (result?.status === 200) {
      localStorage.removeItem("token");
      localStorage.removeItem("auth");
      window.location.pathname = "/";
    }
  };

  return (
    <div className="landing-page-main-container">
      {showDropDown && (
        <div class="dropdown-content">
          <Link to="/dashboard">
            <button className="dashboard-link">Dashboard</button>
          </Link>
          <button className="signin-dropdown" onClick={logoutHandler}>
            Logout
          </button>
        </div>
      )}

      <Topbar setShowDropDown={setShowDropDown} showDropDown={showDropDown} />
      <div onClick={() => setShowDropDown(false)}>
        <Home />
        <Qualities />
        <Working />
        <Services />
        <Chooseus />
        <Reviews />
        <FAQs />
        <OurTeam />
        <Contact />
        <Footer />
        {/* <AboutUs /> */}
      </div>
    </div>
  );
};

export default LandingPage;
